import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Experiencefilter from "./sections/Experiencefilter";
import ExpertiseEtSolutions from "./sections/ExpertiseEtSolutions";
import Multidayretreatpackages from "./sections/Multidayretreatpackages";
import TheBriefingRoom from "./sections/TheBriefingRoom";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Experiencefilter />
      <ExpertiseEtSolutions />
      <Multidayretreatpackages />
      <TheBriefingRoom />
      <Footer />
    </div>;
}